/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable eqeqeq */
/**
 * Product methods
 * -----------------------------------------------------------------------------
 *
 * @namespace product
 */

import axios from 'axios';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fullscreen';
import zoomio from 'zoomio';
import enquire from 'enquire.js';
// import detectIt from 'detect-it';
import scrollMonitor from 'scrollmonitor';

var colorOptionIndex = 0;
var sizeOptionIndex = 0;
var typeOptionIndex = 0;

var productMethods = {
  data: function data() {
    return {
      enableHistoryState: false,
      isProductToolbarMobileOpen: false,
      product: {},
      currentVariant: {},
      product_metafields: {},
      discountPercentage: ''
    };
  },


  methods: {

    /**
     * Product Single
     */
    _initProduct: function _initProduct() {
      var $container = $('[data-template="product"]');
      var $productTabs = $(app.selectors.productTabs);
      var $productToolbarMobile = $(app.selectors.productToolbarMobile);
      var $imageZoom = $(app.selectors.imageZoom);
      var productObj = app.selectors.productObj;

      // product tabs add active class to 1st child
      $productTabs.find('.nav-item').first().find('a').addClass('active');
      $productTabs.find('.tab-content .tab-pane').first().addClass('active');

      // stop parsing if we are not in the product template
      if (app.currentTemplate !== 'product') {
        return;
      }

      // set data
      app.product = JSON.parse($(productObj).html());
      var productData = JSON.parse($(productObj).html());
      app.product = productData.product;
      colorOptionIndex = productData.colorOptionIndex;
      sizeOptionIndex = productData.sizeOptionIndex;
      typeOptionIndex = productData.typeOptionIndex;
      app.product.options_with_values = productData.options_with_values;
      app.product.metafields = productData.metafields;
      app.product.bundleDiscountMetafields = productData.bundleDiscountMetafields;

      app._checkInventory(app.product.id);

      app.product.itsPreorder = null;
      app.product.itsMarketplace = null;
      app.product.marketplaceSaller = null;
      app.product.dropShipping = null;

      // assign the product cart limit
      app.product.tags.forEach(function (tag) {
        if (tag.match('cart-limit')) {
          var cartLimit = tag.replace('cart-limit-', '');
          app.product.cart_limit = parseFloat(cartLimit);
        }
        if (tag.match('preventa_')) {
          var dateCheck = tag.split('preventa_');
          var today = new Date();
          var preorderDate = new Date(dateCheck[1]);
          if (preorderDate > today) {
            app.product.itsPreorder = tag;
          }
        }
        // if (tag.match('MKP') || tag.match('mkp')) {
        //   app.product.itsMarketplace = tag;
        // }
        if (tag.match('seller_')) {
          var marketplaceSaller = tag.split('seller_');
          app.product.marketplaceSaller = marketplaceSaller[1];
        }
        if (tag.match('enverde-')) {
          app.product.dropShipping = tag;
        }
      });

      // get the compare products from the localstorage
      var compareProduct = localStorage.getItem('compareProducts');
      if (compareProduct !== undefined && compareProduct != null) {
        app.compareProducts = compareProduct.split(',');
        if ($.inArray(app.product.handle, app.compareProducts) >= 0) {
          $('input[name="compare_product"]').attr('checked', 'checked');
        }
        app._getComparePro();
      }

      app.enableHistoryState = $container.data('enable-history-state');
      app._getVariant();

      if ($('[data-color] input').length == 1) {
        $('[data-color]').hide();
        $('[data-new-color]').removeClass('d-block').addClass('d-none');
      }
      if ($('[data-size] input').length == 1) {
        $('[data-size]').hide();
        $('[data-new-size]').removeClass('d-block').addClass('d-none');
      }
      if ($('[data-custom-options] input').length == 1) {
        $('[data-custom-options]').hide();
        $('[data-new-custom]').removeClass('d-block').addClass('d-none');
      }

      function registerMobileToolbar() {
        var productFormPosition = $(app.selectors.productForm).position();
        var formWatcher = scrollMonitor.create($(app.selectors.productForm));
        var footerWatcher = scrollMonitor.create($('[data-footer-bottom]'));
        $productToolbarMobile.show();

        window.addEventListener('scroll', function () {
          var windowScrollY = window.scrollY;

          if (windowScrollY > productFormPosition.top) {
            formWatcher.exitViewport(function () {
              $productToolbarMobile.addClass('semi-opened');
            });

            formWatcher.enterViewport(function () {
              $productToolbarMobile.removeClass('semi-opened fully-opened');
              if (app.isProductToolbarMobileOpen) {
                app.isProductToolbarMobileOpen = false;
              }
            });

            footerWatcher.exitViewport(function () {
              $productToolbarMobile.addClass('semi-opened');
            });

            footerWatcher.enterViewport(function () {
              $productToolbarMobile.removeClass('semi-opened fully-opened');
              if (app.isProductToolbarMobileOpen) {
                app.isProductToolbarMobileOpen = false;
              }
            });
          } else {
            $productToolbarMobile.removeClass('semi-opened fully-opened');
            if (app.isProductToolbarMobileOpen) {
              app.isProductToolbarMobileOpen = false;
            }
          }
        }); // add scroll event listener
      }

      // mobile product form - sticky toolbar
      enquire.register('screen and (min-width: 720px)', {
        setup: function setup() {
          registerMobileToolbar();
        },
        match: function match() {
          $productToolbarMobile.hide();

          $imageZoom.zoomio({
            fadeduration: 200
          });
        },
        unmatch: function unmatch() {
          registerMobileToolbar();
        }
      });

      dataLayer.push({
        event: 'productDetails',
        ecommerce: {
          detail: {
            products: [{
              name: app.product.title,
              id: app.currentVariant.id, // Name or ID is required.
              productId: app.product.id,
              price: app._formatMoney(app.product.price),
              sku: app.currentVariant.sku,
              brand: app.product.vendor,
              category: app.product.type, // Utiliza / como delimitador para especificar hasta cinco niveles de jerarquÃ­a (por ejemplo, Ropa/Hombre/Camisetas).
              variant: app.currentVariant.title
            }] }
        }
      });
    },


    /**
     * Event when product option select or input changes
     *
     */
    _getDiscount: function _getDiscount(mPrice, cPrice) {
      var korting = Math.ceil((mPrice - cPrice) / cPrice * 100);
      korting = korting.toString().replace('-', '');
      app.discountPercentage = korting + "%";
    },
    _getVariant: function _getVariant(event) {
      var variant = app._getVariantFromOptions(event);

      // stop parsing if there is no variant info
      if (!variant) {
        app.currentVariant = {};
        return;
      }

      if (variant.price != variant.compare_at_price && variant.price < variant.compare_at_price) {
        app._getDiscount(variant.price, variant.compare_at_price);
      } else {
        app.discountPercentage = '';
      }

      // eslint-disable-next-line max-statements-per-line
      if (colorOptionIndex == 1) {
        app.selectedSwatchColor = variant.option1;
      } else if (colorOptionIndex == 2) {
        app.selectedSwatchColor = variant.option2;
      } else if (colorOptionIndex == 3) {
        app.selectedSwatchColor = variant.option3;
      }
      // eslint-disable-next-line max-statements-per-line
      if (sizeOptionIndex == 1) {
        app.selectedSwatchSize = variant.option1;
      } else if (sizeOptionIndex == 2) {
        app.selectedSwatchSize = variant.option2;
      } else if (sizeOptionIndex == 3) {
        app.selectedSwatchSize = variant.option3;
      }
      // eslint-disable-next-line max-statements-per-line
      if (typeOptionIndex == 1) {
        app.selectedSwatchType = variant.option1;
      } else if (typeOptionIndex == 2) {
        app.selectedSwatchType = variant.option2;
      } else if (typeOptionIndex == 3) {
        app.selectedSwatchType = variant.option3;
      }

      app._updateImages(variant, event);
      app._checkWishlist(variant);

      if (app.isQuickshopModalOpen) {
        app.quickShop.currentVariant = variant;
      } else if (app.currentTemplate === 'collection') {
        // collection
        var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        product.current_variant = variant;
      } else if (app.currentTemplate === 'product' || app.currentTemplate === 'collection') {
        variant.inventory = $("[data-variant-id=\"" + variant.id + "\"]").data('inventory');
        app.currentVariant = variant;
        if (app.enableHistoryState) {
          app._updateHistoryState(variant);
        }
      }
    },


    /**
     * Get the currently selected options from add-to-cart form.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions(event) {
      var singleOptionSelector = app.selectors.singleOptionSelector;
      var currentOptions = [];
      var $container = void 0;

      if (app.isQuickshopModalOpen) {
        $container = $('[data-template="quickshop"]').find(app.selectors.productForm);
      } else {
        $container = event ? $(event.currentTarget).closest(app.selectors.productForm) : $(app.selectors.productForm);
      }

      $.map($(singleOptionSelector, $container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            currentOptions.push(currentOption);
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          currentOptions.push(currentOption);
        }
      });

      return currentOptions;
    },


    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions(event) {
      var selectedValues = app._getCurrentOptions(event);
      var variants = void 0;
      var found = false;

      if (app.isQuickshopModalOpen) {
        // quickshop
        variants = app.quickShop.product.variants;
      } else if (app.currentTemplate === 'collection') {
        // collection
        var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        variants = product.variants;
      } else if (app.currentTemplate === 'product') {
        // product
        variants = app.product.variants;
      }

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },


    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newUrl = void 0;

      var showReviewForm = app._getUrlParameter('showReviewForm');
      var utmForm = app._getUrlParameter('utm_source');

      if (utmForm === '') {
        if (showReviewForm === '') {
          newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
        } else {
          newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id + "&showReviewForm=" + showReviewForm;
        }

        window.history.replaceState({
          path: newUrl
        }, '', newUrl);
      }
    },


    /**
     * Find variant image and scroll to this image
     * works for all product page templates
     * can be extended to update all images upon variant selection
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateImages: function _updateImages(variant, event) {
      var variantImage = variant.featured_image || {};
      var variantTitle = variant.title;
      var templateType = $('[data-product-template]').data('product-template');
      var $scrollTarget = $("[data-variant-title=\"" + variantTitle + "\"]");
      var $container = void 0;
      var currentVariantImage = void 0;

      if (app.isQuickshopModalOpen) {
        $container = $('[data-template="quickshop"]');
        currentVariantImage = app.quickShop.currentVariant.featured_image || {};
      } else if (app.currentTemplate === 'collection') {
        $container = $(event.currentTarget).closest(app.selectors.productForm);
        var productId = $container.data('product-id');
        var product = app.collection.products.find(function (x) {
          return x.id === productId;
        });
        if (product.current_variant.featured_image) {
          currentVariantImage = product.current_variant.featured_image.src || {};
        } else {
          currentVariantImage = product.featured_image || {};
        }
      } else if (app.currentTemplate === 'product') {
        $container = $('[data-template="product"]');
        currentVariantImage = app.currentVariant.featured_image || {};
      }

      var $carousel = $container.find('[data-carousel-main]');

      if (variantImage.src === currentVariantImage.src) {
        return;
      }

      enquire.register('screen and (min-width: 720px)', {
        match: function match() {
          // For the 'minimal' product template
          // Scroll to variant image unless it's the first photo on load
          if (templateType === 'minimal' && !app.isQuickshopModalOpen && $scrollTarget[0]) {
            $('html, body').animate({
              scrollTop: $scrollTarget.offset().top
            }, 350);
          }
        }
      });

      enquire.register('screen and (max-width: 767px)', {
        match: function match() {
          app.isMobile = true;
        }
      });

      if ($carousel.length > 0) {

        var flkty = Flickity.data($carousel[0]);

        if (typeof flkty === 'undefined') {
          return;
        }

        var cellElements = flkty.getCellElements();
        cellElements.forEach(function (element, index) {
          var imgAlt = $(element).data('variant-title');
          if (variantTitle.indexOf(imgAlt) !== -1) {
            flkty.selectCell(index, true, false); // value, isWrapped, isInstant
          }
        });
      }
    },
    _checkInventory: function _checkInventory(pr_id, var_id) {

      var inventoryString = '';
      var API = '';

      var shopifyCommonAPI = axios.create({
        baseURL: '/tools/ha-api/shopify/common',
        headers: {
          Accept: 'application/json'
        }
      });

      var config = {
        "url": '/products/' + pr_id + '.json',
        "method": 'GET',
        "data": []
      };
      try {
        shopifyCommonAPI.post(API, config).then(function (response) {
          response.data.product.variants.forEach(function (intvariant, index) {
            app.product.variants.forEach(function (variant, i) {
              if (variant.id == intvariant.id) {
                app.product.variants[i].inventory_item_id = intvariant.inventory_item_id;
              }
            });

            inventoryString = intvariant.inventory_item_id + ',' + inventoryString;
          });

          inventoryString = inventoryString.replace(/,\s*$/, "");
          var configsub = {
            "url": '/inventory_levels.json?inventory_item_ids=' + inventoryString,
            "method": 'GET'
          };

          shopifyCommonAPI.post(API, configsub).then(function (response) {
            app.product.variants.forEach(function (variant, i) {
              var inventoryTotal = 0;
              response.data.inventory_levels.forEach(function (inventory_level, index) {
                if (inventory_level.location_id != 18980831287) {
                  if (variant.inventory_item_id == inventory_level.inventory_item_id) {
                    inventoryTotal = inventory_level.available + inventoryTotal;
                    app.product.variants[i].inventoryTotal = inventoryTotal;
                  }
                }
              });
            });
          });
        });
      } catch (error) {
        console.log('error');
      }

      setTimeout(function () {
        if ($('.product-details-wrapper .remain.oninv').length > 0) {
          if (app.currentVariant.inventoryTotal > 0 && app.currentVariant.inventoryTotal < 50) {
            $('.product-details-wrapper .remain.oninv .texto span').text(app.currentVariant.inventoryTotal);
            $('.product-details-wrapper .remain.oninv').removeClass('d-none');
          }
          if (app.currentVariant.inventoryTotal >= 50) {
            $('.product-details-wrapper .remain.oninv .texto span').text('50');
            $('.product-details-wrapper .remain.oninv').removeClass('d-none');
          }
          if (app.currentVariant.inventoryTotal == 1) {
            if (app.product.variants.length == 1) {
              $('.product-details-wrapper .remain.oninv .texto').html('Queda <span>1</span> unidad');
            } else {
              $('.product-details-wrapper .remain.oninv .texto span').text('1');
            }
            $('.product-details-wrapper .remain.oninv').removeClass('d-none');
          }
        }
      }, 4000);
    },


    /**
     * Mobile toolbar - product form - options
     */
    _toggleProductToolbarMobile: function _toggleProductToolbarMobile() {
      var $productToolbarMobile = $(app.selectors.productToolbarMobile);
      app.isProductToolbarMobileOpen = !app.isProductToolbarMobileOpen;
      $productToolbarMobile.toggleClass('fully-opened');
    }
  }
};

export default productMethods;